import { render, staticRenderFns } from "./AGB.vue?vue&type=template&id=5d742c10&scoped=true&"
import script from "./AGB.vue?vue&type=script&lang=js&"
export * from "./AGB.vue?vue&type=script&lang=js&"
import style0 from "./AGB.vue?vue&type=style&index=0&id=5d742c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d742c10",
  null
  
)

export default component.exports